var map = {
	"./huwelijksdrukwerk-drukwerk-annonce-trouwen-hannah-kyle-preeg-emboss-origami-1.jpg": "70bd",
	"./huwelijksdrukwerk-drukwerk-annonce-trouwen-hannah-kyle-preeg-emboss-origami-2.jpg": "c8ad",
	"./huwelijksdrukwerk-drukwerk-annonce-trouwen-hannah-kyle-preeg-emboss-origami-3.jpg": "d44e0",
	"./huwelijksdrukwerk-drukwerk-annonce-trouwen-hannah-kyle-preeg-emboss-origami-thumbnail.png": "273d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5789";